(function () {
  // Ecart de prix sur les boutons d'option de la fiche kit.
  //
  // Les boutons "DIY Frame Kit" et "48 Colors" n'annoncent ni leur prix ni ce qu'ils apportent : sur
  // 117 lignes vendues (60 j au 2026-09-21), 48 sont la variante par defaut 16x20 / sans cadre /
  // 36 couleurs. On ajoute a chaque bouton plus cher que la selection courante l'ecart exact,
  // calcule sur les variantes reelles (products/<handle>.js, dans la devise du marche servi), et
  // une ligne sous le choix du cadre qui dit ce qu'est le kit cadre. Rien sur les options moins
  // cheres : l'objet est de rendre visible ce que coute la montee, pas de pousser a descendre.
  //
  // Tout se repere par le rang, jamais par le libelle : sur /fr/ les boutons portent des valeurs
  // traduites ("Cadre à monter soi-même") que le .js sans prefixe de langue ne connait pas. Le rang
  // de l'option dans variant-radios et le rang du bouton dans son groupe suivent l'ordre du .js.
  //
  // Le style et la ligne sous le cadre vivent dans layout/theme.liquid (<head>), pas ici : poses
  // apres le fetch, ils poussaient la page vers le bas. L'ecart est en position absolue sur le
  // bord du bouton, il n'occupe aucune place dans le flux.

  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = m[1];
  var CIBLES = { "Frame Options": 1, "Number of Colors": 1 };
  var produit = null;

  function monnaie(cents) {
    var devise = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    var v = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency", currency: devise,
        minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return v.toFixed(2) + " " + devise; }
  }

  function groupes() {
    var r = document.querySelector("variant-radios");
    return r ? Array.prototype.slice.call(r.querySelectorAll("fieldset.product-form__input")) : [];
  }

  function radios(f) { return Array.prototype.slice.call(f.querySelectorAll("input[type=radio]")); }

  // valeur anglaise du bouton coche de chaque groupe
  function selection(fs) {
    return fs.map(function (f, i) {
      var r = radios(f), k = -1;
      for (var j = 0; j < r.length; j++) if (r[j].checked) k = j;
      var vals = produit.valeurs[i];
      return k >= 0 && r.length === vals.length ? vals[k] : null;
    });
  }

  function variante(valeurs) {
    for (var i = 0; i < produit.variants.length; i++) {
      var v = produit.variants[i], ok = true;
      for (var j = 0; j < valeurs.length; j++) if (v.options[j] !== valeurs[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  function appliquer() {
    var fs = groupes();
    if (!produit || fs.length !== produit.options.length) return;
    var sel = selection(fs);
    if (sel.indexOf(null) !== -1) return;
    var courante = variante(sel);
    if (!courante) return;

    produit.options.forEach(function (nom, i) {
      if (!CIBLES[nom]) return;
      var f = fs[i];
      radios(f).forEach(function (inp, k) {
        var lab = f.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        var vieux = lab.querySelector(".abn-ecart");
        var essai = sel.slice(); essai[i] = produit.valeurs[i][k];
        var v = variante(essai);
        var d = v ? v.price - courante.price : 0;
        var txt = d > 0 ? "+" + monnaie(d) : "";
        if (!txt) { if (vieux) vieux.remove(); return; }
        if (!vieux) { vieux = document.createElement("span"); vieux.className = "abn-ecart"; lab.appendChild(vieux); }
        if (vieux.textContent !== txt) vieux.textContent = txt;
      });
    });
  }

  var attente = null;
  function planifier() { clearTimeout(attente); attente = setTimeout(appliquer, 60); }

  fetch("/products/" + handle + ".js", { credentials: "same-origin" })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.options || !p.variants) return;
      // il faut les valeurs de chaque option (forme objet du .js) pour la correspondance par rang
      if (typeof p.options[0] === "string") return;
      p.valeurs = p.options.map(function (o) { return o.values; });
      p.options = p.options.map(function (o) { return o.name; });
      if (!p.options.some(function (n) { return CIBLES[n]; })) return;
      produit = p;
      appliquer();
      document.addEventListener("change", function (e) {
        if (e.target && e.target.closest && e.target.closest("variant-radios")) planifier();
      });
      // le theme re-rend variant-radios par innerHTML apres un changement de variante
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.closest && t.closest("variant-radios") && !(t.classList && t.classList.contains("abn-ecart"))) { planifier(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () {});
})();
